// Apps Registry - Auto-generated for beta.developmentsnapshot.com
// This file is generated at deploy time for isolated single-app deployments

import * as JobsMonitor from './jobs-monitor';
import * as Shah from './shah';

// App registry - only includes apps for this deployment
export const appRegistry = {
  'jobs-monitor': {
    name: 'Jobs Monitor',
    description: 'Monitor DynamoDB Jobs System operations',
    category: 'Monitoring',
    icon: 'MONITOR',
    color: '#6f42c1',
    exports: JobsMonitor
  },
  'shah': {
    name: 'SHAH',
    description: 'Smart Hub for AI & Humans',
    category: 'Business',
    icon: 'APP',
    color: '#0066cc',
    exports: Shah
  }
};

// Helper to get all available apps as an array
export const getAvailableApps = () => {
  return Object.keys(appRegistry).map(id => ({
    id,
    ...appRegistry[id]
  }));
};

// Helper to get app exports by ID
export const getAppExports = (appId) => {
  return appRegistry[appId]?.exports || null;
};

// Helper to get the default app from deployment config
export const getDefaultApp = () => {
  return null;  // Determined by deployment config at runtime
};
